
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import { routers } from '@/router/router'
    // import { getLodop, demoDownloadPDF } from '@/common/js/LodopFuncs'
    import { GetPrintWorld } from '@/common/js/PrintWorld'
    import UpdatebackstockorderStatu from '@/store/entities/back-updatestatus'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'
    import moment from 'moment'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);
    import VueClipboard from 'vue-clipboard2'
    import { Select } from '../../../types/iview/select';
    Vue.use(VueClipboard)


    class FindStockOrderList extends PageRequest {
        ShelfPosition: string;
        BeginTime?: Date;
        EndTime?: Date;
        isUrgent?: boolean;
        storeId?: number;
        batchName: string;
        constructor() {
            super();
            this.isUrgent = null;
        }
    }

    @Component({
        name: "findstockorder",
    })
    export default class Orders extends AbpBase {
        pagerequest: FindStockOrderList = new FindStockOrderList();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        urgentStatus = Enums.getEnum(Enums.WhetherHandleStatus, true);
        storeaddressList: Array<storeaddressInfo> = [];

        listData: null;
        loading: boolean = false;
        get list() {
            return this.listData;
        };
        handleChangeImg($event) {
            if ($event.currentTarget.className == 'img') {
                $event.currentTarget.className = 'img open';
            } else {
                $event.currentTarget.className = 'img';
            }
        }
        async getpage() {
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }
            this.loading = true;
            var result = await this.$store.dispatch({
                type: 'backstockorder/getFindOrder',
                data: this.pagerequest
            });
            this.listData = result;
            this.loading = false;
        }

        async searchPage() {
            this.getpage();
        }

        exportToExcel() {
            //(this.$refs.table as any).exportCsv({
            //    filename: '数据导出', // 导出的文件名
            //});

            const translatedHeaders = [];
            const headerElements = document.querySelectorAll('.ivu-table-header th');

            headerElements.forEach(th => {
                translatedHeaders.push(th.textContent.trim());
            });

            const exportColumns = this.columns.map((col, index) => ({
                ...col,
                title: translatedHeaders[index] || col.title
            }));
            const timestamp = new Date().getTime(); // 获取时间戳
            const filename = `囤货导出数据_${timestamp}`;

            (this.$refs.table as any).exportCsv({
                filename: filename,
                columns: exportColumns.filter(c => c.key != 'productImgGuid'),
                data: this.listData
            });
        }

        get totalCount() {
            return this.$store.state.backstockorder.totalCount;
        }
        columns = [
            {
                title: '产品编号',
                key: 'productNo',
                width: 200,
            },
            {
                title: '货架号',
                key: 'shelfPosition',
                width: 80,
            },
            {
                title: '内码',
                key: 'productId',
                width: 100,
            },
            {
                title: '数量',
                key: 'count',
                width: 70,
            },
            {
                title: '单品数量',
                key: 'singleCount',
                width: 90,
            }, {
                title: '产品图片',
                key: 'productImgGuid',
                width: 95,
                render: (h: any, params: any) => {
                    if (params.row.productImgGuid) {
                        var data = { imageGuid: params.row.productImgGuid, url: null };
                        var url = "";
                        if (params.row.productImgGuid.indexOf("http") != -1) {
                            url = params.row.productImgGuid;
                        }
                        else {
                            this.$store.commit('expressuserinfo/getImgUrl', data);
                            url = data.url;
                        }
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: "yc_" + params.row.id,
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            {
                title: '库存',
                key: 'inventory',
                width: 100,
            },
            {
                title: '总入库',
                key: 'totalStorage',
                width: 100,
            }
        ]

        async created() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            if (this.storeaddressList.length == 1) {
                this.pagerequest.storeId = this.storeaddressList[0].id;
            }
            else {
                this.storeaddressList.push(a);
                this.pagerequest.storeId = null;
            }

        }
        async mounted() {
        }
    }
